module.exports = __webpack_public_path__ + "static/media/screenshot4.f2bb019a.png";